export const summary = [
  {
    label: '随访方式',
    key: 'followWayDesc'
  },
  {
    label: '随访结果',
    key: 'followupResultDesc'
  },
  {
    label: '转归',
    key: 'transformationDesc'
  },
  {
    label: '投诉',
    key: 'complainDealDesc'
  },
  {
    label: '备注',
    key: 'remark'
  }
]

export const progressBtnType = {
  3: '查看随访结果',
  4: '查看问卷结果'
}
